import { TSearchFilter } from '../../../filters-advanced/models/advanced-filter.model';
import {
  EPointSearchOperator,
  TSearchFilterSubgroup,
} from '../../../points/point-search/point-search.consts';

export function generateBetweenFilter(filter: TSearchFilter): TSearchFilterSubgroup {
  const result: TSearchFilterSubgroup = {
    criteriaOperator: 'OR',
    criteria: [],
    subgroups: [],
  };

  filter.keys.forEach((key) => {
    result.subgroups.push({
      criteriaOperator: 'AND',
      criteria: [
        {
          key: key,
          operator: EPointSearchOperator.GREATER_THAN_OR_EQUAL,
          values: [filter.values[0]],
          timelinePosition: filter.timelinePosition,
        },
        {
          key: key,
          operator: EPointSearchOperator.LESS_THAN_OR_EQUAL,
          values: [filter.values[1]],
          timelinePosition: filter.timelinePosition,
        },
      ],
    });
  });

  return result;
}
